import { ProductOptionalFieldNameEnum } from '@inter-ikea-kompis/enums';
const KompisDefaultFields = [
    ProductOptionalFieldNameEnum.priceInformation,
    ProductOptionalFieldNameEnum.priceUnit,
    ProductOptionalFieldNameEnum.child,
    ProductOptionalFieldNameEnum.measureReference,
    ProductOptionalFieldNameEnum.measure,
    ProductOptionalFieldNameEnum.packageMeasure,
    ProductOptionalFieldNameEnum.customerBenefit,
    ProductOptionalFieldNameEnum.customerBenefitSummary,
    ProductOptionalFieldNameEnum.goodToKnow,
    ProductOptionalFieldNameEnum.peopleAndPlanet,
    ProductOptionalFieldNameEnum.image,
    ProductOptionalFieldNameEnum.video,
    ProductOptionalFieldNameEnum.technicalInformation,
    ProductOptionalFieldNameEnum.complianceTechnical,
    ProductOptionalFieldNameEnum.complianceInformation,
    ProductOptionalFieldNameEnum.complianceLabel,
    ProductOptionalFieldNameEnum.careInstruction,
    ProductOptionalFieldNameEnum.customerMaterial
];
export default KompisDefaultFields;
//# sourceMappingURL=KompisDefaultFields.js.map